<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import SmsLogin from "@/components/login/SmsLogin.vue";
import PasswordLogin from "@/components/login/PasswordLogin.vue";
import {ElMessage} from "element-plus";
import store from "@/store";
import {Base64} from "js-base64";

const logo = require("@/assets/images/scal.jpg")
const prop = defineProps(['showLogin', 'account'])
const emit = defineEmits(['login'])
const show = ref(false)
const checkLogin = ref("sms")
onMounted(() => {
  show.value = prop.showLogin
})
const login = (res) => {
  if (res.message.code !== "000") {
    return ElMessage.error({message: res.message.content})
  }
  res.data.phoneNumber = /^1[2-9]\d{9}/.test(res.data.phoneNumber) ? res.data.phoneNumber : Base64.decode(res.data.phoneNumber)
  store.dispatch("setAccounts", res.data)
  // show.value = false
  emit("login")
}
</script>

<template>
  <el-dialog v-model="show" destroy-on-close width="93.7vw" :show-close="false"
             class="login-dialog" @closed="show=false,emit('login')">

    <template #header>
      <div class="logo">
<!--        <el-image :src="logo"/>-->
        川航金熊猫会员登录
      </div>
    </template>
    <div class="login-tabs">
      <div class="login-tabs-its" :class="checkLogin==='sms'?'login-tabs-checked':''" @click="checkLogin='sms'">
        短信登录
      </div>
      <div class="login-tabs-its" :class="checkLogin==='account'?'login-tabs-checked':''" @click="checkLogin='account'">
        密码登录
      </div>
    </div>
    <sms-login v-if="checkLogin==='sms'" @login="login" :account="prop.account"/>
    <password-login v-if="checkLogin==='account'" @login="login" :account="prop.account"/>
  </el-dialog>
</template>

<style scoped lang="less">
.logo {
  margin: auto;
  font-size: 1.23rem;
  color: #D8000D;
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #D8000D;
}

.login-tabs {
  display: flex;
  align-content: center;
  justify-content: space-between;
  font-size: 1.25rem;
  margin: 10px auto;
  width: 65%;

  .login-tabs-its {
    padding-bottom: 6px;
    border-bottom: 2px solid #ffff;

    &.login-tabs-checked {
      border-bottom-color: #D8000D;
      color: #D8000D;
    }
  }
}
</style>
